import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=0c60e362"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"
import style0 from "./page-loader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../acquisition-utility-tailors/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports